// extracted by mini-css-extract-plugin
export var bottomBar = "qVOpN";
export var bottomBarContainer = "Mezkw";
export var chevronContainer = "pJVcz";
export var outerContainerV9 = "S7qv7";
export var root = "kGvEO";
export var tabContentContainer = "A9JLN";